module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/vip-video-poster-dfa23052ff1d9ae685e975bb0d1807a1.png";